export { fetchGetHeader, dismissFetchGetHeaderError } from './fetchGetHeader';
export { fetchGetFooter, dismissFetchGetFooterError } from './fetchGetFooter';
export { fetchLogin, dismissFetchLoginError } from './fetchLogin';
export { fetchGetPhoneCode, dismissFetchGetPhoneCodeError } from './fetchGetPhoneCode';
export { fetchRegister, dismissFetchRegisterError } from './fetchRegister';
export { fetchGetPhoneCodeByLogin, dismissFetchGetPhoneCodeByLoginError } from './fetchGetPhoneCodeByLogin';
export { fetchEditStuPwd, dismissFetchEditStuPwdError } from './fetchEditStuPwd';
export { fetchLoginByPhone, dismissFetchLoginByPhoneError } from './fetchLoginByPhone';
export { fetchGetConfiguration, dismissFetchGetConfigurationError } from './fetchGetConfiguration';
export { fetchConfigInfo, dismissFetchConfigInfoError } from './fetchConfigInfo';
export { fetchStudentBasics, dismissFetchStudentBasicsError } from './fetchStudentBasics';
export { fectchLoginOut } from './fectchLoginOut';
export { fetchGetShoppingCar, dismissFetchGetShoppingCarError } from './fetchGetShoppingCar';
export { addCartCount } from './addCartCount';
export { clearCartCount } from './clearCartCount';
export { fetchPutInCarts, dismissFetchPutInCartsError } from './fetchPutInCarts';
export { fetchMoveOutCarts, dismissFetchMoveOutCartsError } from './fetchMoveOutCarts';
export { fetchLogout, dismissFetchLogoutError } from './fetchLogout';
export { fetchFeedback, dismissFetchFeedbackError } from './fetchFeedback';
export { fetchGetSearchData, dismissFetchGetSearchDataError } from './fetchGetSearchData';
export { resetSearchTotal } from './resetSearchTotal';
export { fetchGetWebSite, dismissFetchGetWebSiteError } from './fetchGetWebSite';
export { fetchGetAdDefault, dismissFetchGetAdDefaultError } from './fetchGetAdDefault';
export { fetchCheckGuide, dismissFetchCheckGuideError } from "../../center/redux/fetchCheckGuide";
export { fetchGetLookInfo, dismissFetchGetLookInfoError } from "../../center/redux/fetchGetLookInfo";
export { fetchGetWeAppCode, dismissFetchGetWeAppCodeError } from './fetchGetWeAppCode';
export { fetchGetAllDisciplineInfo, dismissFetchGetAllDisciplineInfoError } from "../../course/redux/fetchGetAllDisciplineInfo";
export { fetchGetTeacherList, dismissFetchGetTeacherListError } from './fetchGetTeacherList';
export { fetchGetTeacherBanner, dismissFetchGetTeacherBannerError } from './fetchGetTeacherBanner';
export { fetchGetTeacherInfo, dismissFetchGetTeacherInfoError } from './fetchGetTeacherInfo';
export { fetchGetTeacherAnswer, dismissFetchGetTeacherAnswerError } from './fetchGetTeacherAnswer';
export { fetchGetTeacherAbout, dismissFetchGetTeacherAboutError } from './fetchGetTeacherAbout';
export { delShoppingSuccess } from './delShoppingSuccess';

export { fetchCreatePromoter } from "../../home/redux/fetchCreatePromoter";export { fetchGetDefaultWxImg, dismissFetchGetDefaultWxImgError } from './fetchGetDefaultWxImg';
export { fetchGetPublicAccount, dismissFetchGetPublicAccountError } from './fetchGetPublicAccount';



// WEBPACK FOOTER //
// ./src/features/common/redux/actions.js